import {StringHelper} from "~/helpers/stringHelper"

export default {
  filters: {
    pluralize: StringHelper.pluralize,
  }
};
